import React, { FC } from 'react'

type Props = {
	letters: string
	cols: number
}

/**
 * A simplified view of the daily board (or a custom board) to use here and
 * there, such as in the game's menu, or in the instructions.
 */
const BoardPreview: FC<Props> = ({ letters, cols }) => {
	const colElems: React.ReactNode[] = []

	for (let c = 0; c < cols; c++) {
		const letterElems: React.ReactNode[] = []
		for (let r = 0; r < cols; r++) {
			// This is complicated to explain, but basically it assumes that the letters we were given
			// were in the order of left-to-right, starting with the top row.
			const letter = letters[r * 5 + c]
			if (!letter) continue
			letterElems.push(
				<div className="letter" key={`${c}_${r}`}>
					<div className="letter__inner">{letter}</div>
				</div>
			)
		}
		const col = (
			<div className="board__col" key={c}>
				{letterElems}
			</div>
		)
		colElems.push(col)
	}

	return <div className={`board board--cols-${cols} board--preview`}>{colElems}</div>
}

export default BoardPreview
